import type { ClaimFlagConfiguration } from './types';

export interface ClaimScope {
  lob?: string;
  subOrganizationId?: number | null;
  subOrganizationEnabled?: boolean;
}

/**
 * Mirrors the backend runtime scope check (claim_flag_manager._flag_matches_claim_scope). Sub-org scope is
 * a no-op only when sub-orgs are explicitly disabled — an absent/loading context stays strict, matching what
 * the backend accepts on apply.
 */
export const isFlagInClaimScope = (
  config: ClaimFlagConfiguration,
  { lob, subOrganizationId, subOrganizationEnabled }: ClaimScope
): boolean => {
  const lobMatches = config.is_all_lobs || (!!lob && (config.lobs ?? []).includes(lob));
  const subOrgMatches =
    config.is_all_sub_orgs ||
    subOrganizationEnabled === false ||
    (typeof subOrganizationId === 'number' && (config.sub_organization_ids ?? []).includes(subOrganizationId));
  return lobMatches && subOrgMatches;
};
